import firebase from 'firebase/app';
import "firebase/auth";
import 'firebase/firestore';
import 'firebase/database';
import firebaseConfig from './firebaseConfig';
export default firebase.initializeApp(firebaseConfig);
// export default firebaseApp.firestore()
